import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import { Typography } from '@mui/material';
import { useTranslate } from '@si/utils';

import { Stack } from '../Stack/Stack';
import { useColors, useWidth } from '../ThemeProvider';

export function MaintenanceBanner() {
  const { ink, warning, warningLight } = useColors();
  const { isMobile } = useWidth();
  const { t, translate } = useTranslate();

  return (
    <Stack
      component="section"
      role="status"
      aria-live="polite"
      direction="row"
      alignItems="center"
      gap="0.75rem"
      px={isMobile ? '1rem' : '6rem'}
      py="0.75rem"
      sx={{
        backgroundColor: warningLight,
        borderBottom: `0.1rem solid ${warning}`,
      }}
    >
      <ReportProblemOutlined sx={{ color: ink, flexShrink: 0 }} />

      <Stack gap="0.125rem">
        <Typography
          color={ink}
          fontSize="0.875rem"
          fontWeight="bold"
          maxWidth="75ch"
          sx={{ wordBreak: 'break-word', wordWrap: 'break-word' }}
        >
          {translate(t.maintenanceBannerTitle)}
        </Typography>
        <Typography
          color={ink}
          fontSize="0.875rem"
          maxWidth="75ch"
          whiteSpace="pre-wrap"
          sx={{ wordBreak: 'break-word', wordWrap: 'break-word' }}
        >
          {translate(t.maintenanceBannerDescription)}
        </Typography>
      </Stack>
    </Stack>
  );
}
